
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import RadioButton from '@/components/radio-button.vue'
  import PageFooter from '@/components/page-footer.vue';
  import {
    getRewardEarningList
  } from '@/api/statistic'
    import {
    grade
  } from '@/utils/config';

  @Component({
    name: 'member-prize',
    components: {
      RadioButton,
      PageFooter
    }
  })
  export default class MemberPrize extends Vue {
    private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
    private list: any = [];
    private radioType = 0;
    private roleType = 0;
    private memberKey = '';
    private IDKey = '';
    private phoneKey = '';
    private radioList = [{
      label: '联创',
      value: 0
    }, {
      label: '核心',
      value: 1
    }, {
      label: '总代',
      value: 2
    }]
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private gradeList = grade;

    private mounted() {
      this.getList()
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      this.memberKey = '';
      this.IDKey = '';
      this.phoneKey = '';
      this.pageNo = 1;
      this.getList();
    }


    private async getList() {
      let params: any = {
        page_no: this.pageNo,
        page_size: this.pageSize,
        level: this.radioType,
      }
      if (this.memberKey) {
        params.name = this.memberKey;
      }
      if (this.phoneKey) {
        params.phone = this.phoneKey;
      }
      try {
        const res: any = await getRewardEarningList(params);
        this.list = res.info || [];
        this.total = res.count;
      }catch(e) {
        console.log(e);
      }
    }
  }
